import React from "react"
import SectionHeader from "../../molecules/SectionHeader"
import Title from "../../atoms/Title"
import "./styles.scss"

const Steps = ({ steps, title, subtitle }) => {
  return (
    <section className="section section--steps">
      <div className="wrapper--text">
        <SectionHeader
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          type="h2"
          subtitle={subtitle}
        >
          {title}
        </SectionHeader>
        <div className="steps">
          {steps.map((step, index) => {
            return (
              <div key={index} className="step">
                <span className="stepIndex">
                  {index + 1 <= 9 ? "0" : ""}
                  {index + 1}
                </span>
                <Title type="h4" className="stepTitle">
                  {step.title}
                </Title>
                <p className="stepDescription">{step.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Steps
